// extracted by mini-css-extract-plugin
export default {"container":"ContextEnricher_container__1Cwcv"};